// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cYXc","content":"styles_content__22tdb","wrapper":"styles_wrapper__3Ri6l"};